const NAMESPACE = "pc-app-layout";

const KEYS = {
    errorDialogCorrelationIdLabel: "errorDialogCorrelationIdLabel",
    errorDialogTimestampLabel: "errorDialogTimestampLabel"
};

const MESSAGES = {
    [KEYS.errorDialogCorrelationIdLabel]: {
        value: "Correlation ID:",
        comment: "Label for the correlation ID shown in a generic error dialog"
    },
    [KEYS.errorDialogTimestampLabel]: {
        value: "Timestamp:",
        comment: "Label for the timestamp shown in the generic error dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
